import { MonitorAlertFullDto } from '@/app/Alert/types';

export type SidecarMessage =
  | {
    sidecarMessage: 'openMap';
    lat: number;
    lng: number;
    zoom: number;
    alertData: MonitorAlertFullDto;
    currentTime: string;
  }
  | {
    sidecarMessage: 'noAlert';
  }
  | { sidecarMessage: 'loaded' };

export const isSidecarEvent = (obj: object): obj is SidecarMessage => 'sidecarMessage' in obj;